import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';

import Can from './../../Can';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import esLocale from 'date-fns/locale/es';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { green, red } from '@material-ui/core/colors';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CardContent from '@material-ui/core/CardContent';
import { Alert, AlertTitle } from '@material-ui/lab';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';

import { CompanySelect } from './../../Common/Selects/Company';
import { GenericSelect } from './../../Common/Selects/Generic';

import { getSessionCookie } from './../../../services/session';

import DriversServices from './../../../services/api/drivers';
import ClientsService from './../../../services/api/clients';

const useStyles = makeStyles({
  table: {
    marginTop: '10px',
  },
  cardContent: {
    padding: '0px !important',
  },
  card: {
    marginTop: '1rem',
  },
  chipActive: {
    backgroundColor: green[100],
    color: green[700],
  },
  chipInactive: {
    backgroundColor: red[100],
    color: red[700],
  },
  select: {
    width: '100%',
    marginTop: '1em',
    marginBottom: '1em',
  },
  clientSelect: {
    marginBottom: '12px',
  },
});

const RedButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
}))(Button);

const GreenButton = withStyles((theme) => ({
  root: {
    color: 'white', //theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
}))(Button);

const localeMap = {
  es: esLocale,
};

export const DriversCreate = () => {
  const classes = useStyles();
  let history = useHistory();
  const [locale] = useState('es');

  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = React.useState([]);
  const [requestError, setRequestError] = useState({
    error: false,
    errorDescription: null,
  });
  const [role, setRole] = React.useState('logged');

  const [driver, setDriver] = React.useState({
    status: true,
    clientId: '',
    companyId: '',
  });

  //Handle Session Role
  useEffect(() => {
    let session = getSessionCookie();
    if (
      session !== undefined &&
      session.role !== undefined &&
      session.role !== null
    ) {
      setRole(session.role);
    }
  }, [role]);

  const handleStatusChange = (event) => {
    setValue('status', event.target.value);
    setDriver({ ...driver, status: event.target.value });
  };

  const handleExpirationDateChange = (date) => {
    setValue('expiration_date', date);
    setDriver({ ...driver, expiration_date: date });
  };

  let driverSchema = yup.object().shape({
    name: yup.string().required(),
    address: yup.string().required(),
    email: yup.string().required(),
    phone1: yup.string().required(),
    phone2: yup.string(),
    expiration_date: yup.string().required(),
    username: yup.string().required(),
    password: yup.string().required(),
    status: yup.boolean().required(),
    companyId: yup.number(),
    clientId: yup.number().required(),
  });

  const { handleSubmit, errors, control, setValue } = useForm({
    validationSchema: driverSchema,
  });

  const onSubmit = (data) => {
    setIsLoading(true);
    setRequestError({ error: false, errorDescription: null });

    //Request
    setTimeout(function () {
      //Request
      DriversServices.create(data)
        .then((response) => {
          if (response === null || !response.IsValid) {
            throw response.Message;
          }
          if (response.IsValid && response.Data !== undefined) {
            history.push(`/drivers/detail/${response.Data.UsuarioID}`);
          } else {
            throw response.Message;
          }
        })
        .catch((e) => {
          setRequestError({
            error: true,
            errorDescription: e.status ? e.Data.Message : e,
          });
          setIsLoading(false);
        });
    }, 1000);
  };

  const handleCompanyChange = (value) => {
    setValue('companyId', value);
    setDriver({ ...driver, companyId: value });
  };

  const handleClientChange = (value) => {
    setValue('clientId', value);
    setDriver({ ...driver, clientId: value });
  };

  //Handle Clientes Select Content
  useEffect(() => {
    let isCancelled = false;
    let session = getSessionCookie();

    if (
      session !== undefined &&
      session.role !== undefined &&
      session.role !== null
    ) {
      setRole(session.role);
    }
    //Request
    if (driver.companyId !== '' || session.role === 'client') {
      ClientsService.getList(driver.companyId !== '' ? driver.companyId : null)
        .then((response) => {
          if (response === null || !response.IsValid) {
            throw response.Message;
          }
          //
          if (response && response.Data !== undefined) {
            if (!isCancelled) {
              setClients(response.Data);
            }
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });
    }

    return () => {
      isCancelled = true;
    };
  }, [driver.companyId]);

  return (
    <React.Fragment>
      <Card className={classes.card} style={{ background: '#f4f6f8' }}>
        <CardContent>
          <form
            className={classes.form}
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            {isLoading ? (
              <Skeleton count={5} height={50} />
            ) : (
              <React.Fragment>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignContent="center"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Grid item sm={6} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="name"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="name"
                      label="Nombre del Chofer"
                      autoComplete="name"
                      autoFocus
                      error={errors.name ? true : false}
                    />

                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="username"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="username"
                      label="Nombre de Usuario"
                      autoComplete="username"
                      error={errors.username ? true : false}
                    />

                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="address"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="address"
                      label="Direccion"
                      autoComplete="address"
                      error={errors.address ? true : false}
                    />

                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="phone1"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="phone1"
                      label="Telefono 1"
                      autoComplete="phone1"
                      error={errors.phone1 ? true : false}
                    />

                    <Can
                      role={role}
                      perform="clients:read"
                      yes={() => (
                        <GenericSelect
                          className={classes.clientSelect}
                          parentCallback={handleClientChange}
                          parentExtraCallback={handleCompanyChange}
                          itemKey="TipoUsuarioID"
                          label="Clientes"
                          itemValue="TipoUsuarioID"
                          itemText="Nombre"
                          inputName="clientId"
                          itemExtra="ClienteID"
                          items={clients.length > 0 ? clients : []}
                          control={control}
                          error={errors.clientId ? true : false}
                        />
                      )}
                      no={() => ''}
                    />
                  </Grid>

                  <Grid item sm={6} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="email"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="email"
                      label="Email"
                      autoComplete="email"
                      error={errors.email ? true : false}
                    />

                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="password"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="password"
                      label="Contraseña"
                      autoComplete="password"
                      error={errors.password ? true : false}
                    />

                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <Controller
                        as={
                          <KeyboardDatePicker
                            inputVariant="outlined"
                            margin="normal"
                            label="Fecha de Expiracion"
                            id="expiration_date"
                            name="expiration_date"
                            fullWidth
                            disablePast={true}
                            format={'dd/MM/yyyy'}
                            autoOk
                            value={driver.expiration_date || ''}
                            onChange={handleExpirationDateChange}
                          />
                        }
                        control={control}
                        name="expiration_date"
                        required
                        error={errors.expiration_date ? true : false}
                      />
                    </MuiPickersUtilsProvider>

                    <Controller
                      as={
                        <FormControl
                          variant="outlined"
                          className={classes.select}
                        >
                          <InputLabel id="status-label">Estado</InputLabel>
                          <Select
                            labelId="status-label"
                            id="status"
                            autoWidth
                            value={driver.status}
                            onChange={handleStatusChange}
                            label="Estado"
                          >
                            <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem>
                          </Select>
                        </FormControl>
                      }
                      className={classes.select}
                      name="status"
                      defaultValue={driver.status}
                      control={control}
                    />
                    <Can
                      role={role}
                      perform="companies:read"
                      yes={() => (
                        <CompanySelect
                          parentCallback={handleCompanyChange}
                          companyId={driver.companyId}
                          control={control}
                          error={errors.companyId ? true : false}
                        />
                      )}
                      no={() => ''}
                    />
                  </Grid>
                  <Grid item xs sm>
                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      justifyContent="flex-end"
                    >
                      <Grid item>
                        <GreenButton
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classes.button}
                          startIcon={<SaveIcon />}
                        >
                          Guardar Cambios
                        </GreenButton>
                      </Grid>
                      <Grid item>
                        <RedButton
                          component={Link}
                          to="/drivers"
                          variant="contained"
                          color="secondary"
                          size="large"
                          className={classes.button}
                          startIcon={<CancelIcon />}
                        >
                          Cancelar
                        </RedButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {requestError.error && (
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    justifyContent="flex-end"
                  >
                    <Grid item xs>
                      <Alert severity="error">
                        <AlertTitle>Algo salió mal</AlertTitle>
                        {requestError.errorDescription}
                      </Alert>
                    </Grid>
                  </Grid>
                )}
              </React.Fragment>
            )}
          </form>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};
